// Home page (pages/index.tsx), the shared voice/collection/collab cards
// (components/home/JamCards.tsx, used site-wide) and the Discord CTA.
// The hero links reuse nav.footer.aiCover / nav.footer.voiceChanger /
// nav.train, and the Discord CTA reuses nav.discordAria / nav.discordJoin.
// See messages/README.md for how to add strings.
export const home = {
  en: {
    "home.seo.title": "Jammable | Create AI Covers with your Favorite Voices!",
    "home.seo.description":
      "Create AI covers in seconds with Jammable, with thousands of community uploaded AI voice models available for creative use now!",
    "home.seo.ogTitle":
      "Jammable | Create AI Covers with Your Favorite Voices | AI-Powered Music Creation",
    "home.seo.imageAlt": "Jammable - Create AI Covers",

    // Hero. The h1 is "Create <highlight>AI covers</highlight> with your
    // favourite voices".
    "home.hero.views": "10 billion+ views on TikTok, YouTube and Instagram",
    "home.hero.titleBefore": "Create",
    "home.hero.titleHighlight": "AI covers",
    "home.hero.titleAfter": "with your favourite voices",
    "home.hero.subtitle":
      "Pick from 60,000+ AI voices, add your audio, and get it back in seconds.",
    "home.hero.decorVoice": "AI voice",
    "home.hero.decorCover": "cover",
    "home.hero.searchLabel": "Search voices",
    "home.hero.searchPlaceholder": "Search 60,000+ voices",
    "home.hero.searchButton": "Search",
    "home.hero.makeCover": "Make a cover",

    "home.categories.all": "See all categories",
    "home.recent": "Jump back in",
    "home.trending": "Trending now",
    "home.seeAll": "See all",

    // "Train your own <highlight>AI voice</highlight>"
    "home.train.kicker": "60,000+ voices started this way",
    "home.train.titleBefore": "Train your own",
    "home.train.titleHighlight": "AI voice",
    "home.train.body":
      "Build a voice from a few samples, then make covers in a voice nobody else has.",
    "home.train.step1": "Upload your samples",
    "home.train.step1Sub": "A short clip of clear vocals is all you need",
    "home.train.step2": "We train your model",
    "home.train.step2Sub": "Your custom voice is ready in minutes",
    "home.train.step3": "Make covers with it",
    "home.train.step3Sub": "Use it in your covers, whenever you want",

    "home.topCollections": "Top collections",
    "home.collabs": "Trending collabs",
    "home.collection": "Collection",

    // Cards (components/home/JamCards.tsx)
    "home.card.uses": "{n} uses",
    "home.card.voices": "{n} voices",
    "home.card.likes": "{n} likes",
    "home.card.by": "by @{user}",
    "home.card.madeToday": "{n} made today",
    "home.card.makeDuet": "Make this duet",

    // Discord CTA (components/DiscordCta.js)
    "home.discord.bannerSub":
      "Share covers, request voices and get help from the community",
    "home.discord.online": "{n} online",
    "home.discord.members": "{n} members",
    "home.discord.joinDiscord": "Join Discord",
    "home.discord.softSub": "Share covers, request voices, get tips",
    "home.discord.cardSub": "Get help, share covers, find new voices",
    "home.discord.join": "Join",
  },
};
